import { isKrugOrWhispering } from '@/utils/millesimaUtils';
import { PAGES } from '@/constants/pages';
import { SEO_TYPES } from '@/constants/seo';

export const formatUrl = (url, isSpirit = false, storeInfo) => {
  if (storeInfo?.urlWithLocale && storeInfo?.urlPrefix) {
    if (url?.startsWith(`/${storeInfo.urlPrefix}/`) || url?.startsWith('http')) {
      return url;
    } else {
      return `/${storeInfo.urlPrefix}/${isSpirit ? 'spirits/' : ''}${url}`;
    }
  } else if (url?.charAt(0) === '/' || url?.startsWith('http')) {
    return url;
  } else {
    return `/${isSpirit ? 'spirits/' : ''}${url}`;
  }
};

export const getHrefForCategLink = (seoKeyword, id, isSpirit = false) => {
  if (isKrugOrWhispering(seoKeyword)) {
    return formatUrl(seoKeyword);
  } else if (isSpirit) {
    return {
      pathname: `${PAGES.SPIRIT}/[...spiritSlug]`,
      query: {
        spiritSlug: [seoKeyword],
        type: SEO_TYPES.CATEG_SPIRIT,
        id
      }
    };
  } else {
    return {
      pathname: '/[...slug]',
      query: {
        slug: [seoKeyword],
        type: SEO_TYPES.CATEG,
        id
      }
    };
  }
};

export const getHrefForProductLink = (seoKeyword, id, partnumber, isSpirit = false) => {
  if (isSpirit) {
    return {
      pathname: `${PAGES.SPIRIT}/[...spiritSlug]`,
      query: {
        id,
        spiritSlug: [seoKeyword],
        type: SEO_TYPES.PRODUCT_SPIRIT,
        current: partnumber
      }
    };
  } else {
    return {
      pathname: '/[...slug]',
      query: {
        id,
        slug: [seoKeyword],
        type: SEO_TYPES.PRODUCT,
        current: partnumber
      }
    };
  }
};
